import { Tags } from "../../../shared/models/tags.model.ts";
import { getToken } from "../../../shared/utils/common.tsx";
import { TagSerializer } from "../serializers/tagSerializer.ts";

export class CommandUnLinkTemplateToTag {
    async run(templateId: number, tagsIds: Number[]) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${templateId}/tags/`
        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                body: JSON.stringify({tag_ids:tagsIds})
                })
            .then(response =>  response.json())
            .then(json => json)
            .catch(err => console.log(err));
            if(response) {
                return response;
                // return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): Tags[] {
        const serializer = new TagSerializer();
        return serializer.deserializeList(data);
    }
}
